<button routerLink="/auth/login" class="column" type="button" mat-button color="secondary">
  <mat-icon iconPositionStart>arrow_back</mat-icon>
  RECOVER YOUR PASSWORD
</button>

<div class="validate-form">
  <div class="column">
    <div class="FillInWithTheCodeSentToYourEmailAddress" style="width: 100%; color: #424242; font-size: 16px; font-family: Roboto; font-weight: 400; line-height: 28px; letter-spacing: 0.15px; word-wrap: break-word">Fill in with the code sent to your email address</div>
  </div>
  <div class="column">
    <div class="row">
      <code-input [isCodeHidden]="false"
                  [codeLength]="4"
                  (codeChanged)="onCodeChanged($event)"
                  (codeCompleted)="onCodeCompleted($event)">
      </code-input>
    </div>
    <div class="row">

    </div>
  </div>
  <br />
  <div  >
    <button (click)="validateCode()" [disabled]="code.length < 4" class="button-tourist" mat-button>CONFIRM CODE
      <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
    </button>
  </div>
  <br />
  <button (click)="resendCode()" class="button-tourist" type="reset" mat-button>RESEND CODE
    <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
  </button>
</div>
